import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ERulerActionType } from './types';

export const enableRuler = actionGenerator<ERulerActionType.RulerEnabled>(ERulerActionType.RulerEnabled);
